import { Typography } from '@mui/material';

import { Card } from 'src/components';
import { Flex } from 'src/components/Flex';

interface DetailsProp {
    statementId: string;
    statementDate: string;
    startDate: string;
    endDate: string;
}

const StatementDetails = ({ statementId, statementDate, startDate, endDate }: DetailsProp) => {
    return (
        <Card gap="36px">
            <Flex flexDirection="row" gap="24px">
                <Typography fontSize="20px" fontWeight="800" lineHeight="20px" color="#1d1d1b">
                    Statement Details
                </Typography>
            </Flex>
            <Flex flexDirection="row" gap="24px">
                <Flex flexDirection="column">
                    <Flex>
                        <strong>Statement ID</strong>
                    </Flex>
                    <Flex>
                        <span>{statementId}</span>
                    </Flex>
                </Flex>
                <Flex flexDirection="column">
                    <Flex>
                        <strong>Statement Date</strong>
                    </Flex>
                    <Flex>
                        <span>{statementDate}</span>
                    </Flex>
                </Flex>
            </Flex>
            <Flex flexDirection="row" gap="19px">
                <Flex flexDirection="column">
                    <Flex>
                        <strong>Statement Period</strong>
                    </Flex>
                    <Flex>
                        <span>
                            {startDate} - {endDate}
                        </span>
                    </Flex>
                </Flex>
            </Flex>
        </Card>
    );
};

export default StatementDetails;
